module.exports = __webpack_public_path__ + "static/media/09-speaker_profile.303051de.webp";